exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cube-slide{min-height:1px}.cube-slide,.cube-slide-group{position:relative;height:100%;overflow:hidden}.cube-slide-group{white-space:nowrap;-webkit-transition-property:-webkit-transform;transition-property:-webkit-transform;transition-property:transform;transition-property:transform,-webkit-transform}.cube-slide-dots{position:absolute;bottom:2px;right:0;left:0;padding:0 6px;font-size:0;text-align:center;-webkit-transform:translateZ(1px);transform:translateZ(1px)}.cube-slide-dots>span{display:inline-block;vertical-align:bottom;margin:0 1px;width:10px;height:1px;background:#ccc}.cube-slide-dots>span.active{background:#fc9153}", ""]);

// exports
